import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild } from '@angular/core';
import { CommonModule, formatDate  } from '@angular/common';
import { PlanificacionService } from '../../../../services/planificacion.service';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from "../../../modal/modal.component";
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha'; // Importa las clases idioma fecha

@Component({
  selector: 'app-programacion-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ModalComponent, NgbDatepickerModule ],
  templateUrl: './programacion-form.component.html',
  styleUrl: './programacion-form.component.css',
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})

export class ProgramacionFormComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() year?: number;
  @Input() user?: any;
  @Input() idOrg?: any;
  @Input() idMetaRegional?: any;
  @Input() estudiante_organizacion?: any;
  @Input() nomOrganizacion?: any;
  //@Input() id_empresas?: any;
  @Input() id_ambito?: string;
  @Input() cupo_org?: number;
  @Output() vuelve = new EventEmitter<any>();

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  errorMessage: string = '';
  ocupaciones: any = [];
  perfiles: any = [];
  turno: any = [];
  alternativa: any = [];
  tipo_formador: any = [];
  filtroOcupa: any;
  listarFormador: any = [];
  listarUnidadFormador: any[] = [];
  organizaciones: any = [];
  arrEstudianteOrganizacion: any[][] = [];

  fechaActual: string = '';
  fechaMas7: string = '';

  espacio: boolean = false;

  valida: boolean = true;

  formularioProgramacion: FormGroup

  espaciosList: string[] = [
    "Centro de Formación Socialísta",
    "Organización",
    "Otro"
  ]

  private servicios = inject(PlanificacionService);
  private fb = inject(FormBuilder)

  constructor(){
    this.formularioProgramacion = this.fb.group({
      id_alternativa_cumplimiento: new FormControl('', [Validators.required]),
      espacio_formacion: new FormControl('1'),
      otro_espacio: new FormControl(''),
      id_ocupacion: new FormControl(''),
      datosUC: this.fb.array([])
    });
  }

  ngOnInit(): void {

    //console.log('organizacion empresas:  ', this.idOrg);
    //console.log('empresas:  ', this.id_empresas);
    //console.log('organizaciones estudiantes:', this.estudiante_organizacion)

    //this.idOrg.forEach((org:any) => { this.organizaciones.push(org.id_organizacion); });
    this.organizaciones = this.idOrg.map((org:any) => { return org.id_organizacion; });
    this.arrEstudianteOrganizacion = this.estudiante_organizacion.map((org:any) => {
      return [org.id_organizacion, org.estudiantes.map((est:any) => est.id_estudiante)];
    });


    console.log('conversion por id: ', this.organizaciones);
    console.log('conversion por id estudiante: ', this.arrEstudianteOrganizacion);

    this.servicios.listarOcuopacion(this.user.id_rol).subscribe({
      next: (rs) => {
        this.ocupaciones = rs.data.organizaciones
        this.alternativa = rs.data.alternativa_cumplimiento
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
    console.log('datos usuario: ',this.user)
    const fecha = new Date();
    this.fechaActual = formatDate(fecha, 'dd-MM-yyyy', 'en-US'); // Formato: día/mes/año
    this.fechaMas7 = formatDate((fecha.setDate(fecha.getDate() + 7)), 'dd-MM-yyyy', 'en-US'); // Suma 7 días a la fecha
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  get datosUC() {
    return this.formularioProgramacion.get("datosUC") as FormArray
  }

  unidadesCurriculares(id: number) {
    return (this.formularioProgramacion.get('datosUC') as FormArray)?.at(id)?.get('unidadesCurriculares') as FormArray;
  }

  datos_ocupacion(ev: any){
    let e = ev.target.value
    this.turno = [];
    this.tipo_formador = [];
    this.filtroOcupa = this.ocupaciones.filter((v:any) => { if(v.id_ocupacion == e) return v; });
    this.mdl.cargando();
    this.servicios.listarPerfil(e).subscribe({
      next: (rs) => {
        const miArray: { key: string; value: any }[] = Object.entries(rs.data.ofertas_formativa).map(([key, value]) => ({ key, value }));
        const mover_principio = this.servicios.moverObjeto180AlPrincipio(miArray);
        this.perfiles = this.servicios.identificarDuplicadosEnTodoArray(mover_principio);
        this.turno = rs.data.turnos
        this.tipo_formador = rs.data.tipo_formador
        this.datosUC.clear();
        this.mdl.cerrar();
        const fechaInicio = this.convierteDtpick(this.fechaActual);
        const fechaFin = this.convierteDtpick(this.fechaMas7);
        console.log("Datos recibidos perfiles: ", this.perfiles);
        for (let i = 0; i < this.perfiles.length; i++) {
          const v = this.perfiles[i];
          // Creamos un FormGroup para cada 'key' y le asignamos el FormArray de UCs
          this.datosUC.push(
            this.fb.group({
              perfilId: [v.key], // Almacenamos la 'key' por si la necesitas
              unidadesCurriculares: this.fb.array([])
            })
          );
          const unidadesCurricularesArray = this.unidadesCurriculares(i)
          v.value.forEach((uc:any) => {
            unidadesCurricularesArray.push(
              this.fb.group({
                codigo_of: [uc.codigo_of == null ? '' : uc.codigo_of],
                horas: [uc.horas == null ? '' : uc.horas],
                id_oferta_formativa: [uc.id_oferta_formativa == null ? '' : uc.id_oferta_formativa],
                id_perfil_productivo: [uc.id_perfil_productivo == null ? '' : uc.id_perfil_productivo],
                modalidad: [uc.modalidad == null ? '' : uc.modalidad],
                nombre_oferta: [uc.nombre_oferta == null ? '' : uc.nombre_oferta],
                id_turno: ['1', Validators.required],
                fecha_inicio: [fechaInicio, Validators.required],
                fecha_culminacion: [fechaFin, Validators.required],
                id_tipo_formador: ['', Validators.required],
                id_formador: ['', Validators.required]
              })
            );
          });
        }
        console.log('Formulario perfilesFormArray: ', this.formularioProgramacion.value);
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }



  async getFormador(idp: number, idu: number){
    let tp = this.unidadesCurriculares(idp).at(idu)
    let id_turno = tp.get('id_turno')?.getRawValue();
    const fechaInicio: NgbDateStruct = tp.get('fecha_inicio')?.getRawValue();
    const fechaFin: NgbDateStruct = tp.get('fecha_culminacion')?.getRawValue();
    let id_tipo_formador = tp.get('id_tipo_formador')?.getRawValue();

    if(fechaInicio && fechaFin && id_tipo_formador != "" ){
      const fechaInicioFormat = `${fechaInicio.year}-${this.convertior(fechaInicio.month)}-${this.convertior(fechaInicio.day)}`;
      const fechaFinFormat = `${fechaFin.year}-${this.convertior(fechaFin.month)}-${this.convertior(fechaFin.day)}`;

      if (Date.parse(fechaInicioFormat) > Date.parse(fechaFinFormat)){
        tp.get('id_formador')?.setValue('');
        tp.get('id_tipo_formador')?.setValue('');
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = 'La fecha de ingreso no puede ser mayor a la fecha de culminación.';
        this.mdl.alerta();
      }
      else{
        let datos = {
          "id_tipo_formador": parseInt(id_tipo_formador),
          "id_turno": parseInt(id_turno),
          "id_estado": this.user.id_estado,
          "fechaInicioFormat": fechaInicioFormat,
          "fechaFinFormat": fechaFinFormat,
        }
        this.mdl.cargando();

        await this.servicios.listarFormador(datos).subscribe({
          next: (rs) => {
            this.mdl.cerrar();
            this.listarFormador = rs.data;
            this.listarUnidadFormador[idu] = rs.data
            console.log("Datos recibidos organizacion: ", rs.data);
          },
          error: (error) => {
            this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          }
        });
      }

    }
  }

  convertior(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  verificador(){
    console.log('prueba:  ',this.unidadesCurriculares(0).value)
    for (let i = 0; i < (this.unidadesCurriculares(0).value).length; i++) {
      const e = (this.unidadesCurriculares(0).value)[i];
      if (e.id_formador == ""){
        this.valida = true;
        break;
      }
      else{
        this.valida = false;
      }
    }
  }


  mensaje_validador(){
    if(this.valida){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Debe llenar todos los campos del ciclo formativo inicial.';
      this.mdl.alerta();
    }
  }

  select_espacio(){
    let espacio_formacion = this.formularioProgramacion.get('espacio_formacion')?.getRawValue();
    this.espacio = espacio_formacion == 'Otro' ? true : false;
  }

  async cargar(){

    for (let i = 0; i < ((this.formularioProgramacion.value).datosUC).length; i++) {
      const element = this.unidadesCurriculares(i).value;
      let j = -1
      element.forEach((dt:any) => {
        j += 1;
        if(dt.fecha_inicio != "" && dt.fecha_culminacion != ""){
          const fechaInicio: NgbDateStruct = this.unidadesCurriculares(i).at(j).get('fecha_inicio')?.getRawValue();
          const fechaFin: NgbDateStruct = this.unidadesCurriculares(i).at(j).get('fecha_culminacion')?.getRawValue();
          dt.fecha_inicio = `${fechaInicio.year}-${this.convertior(fechaInicio.month)}-${this.convertior(fechaInicio.day)}`;
          dt.fecha_culminacion = `${fechaFin.year}-${this.convertior(fechaFin.month)}-${this.convertior(fechaFin.day)}`;
        }
      });
    }


    Object.assign(this.formularioProgramacion.value, {
      'id_meta_regional': this.idMetaRegional,
      'pre_impreso': `MP${this.user.acronimo_estado}${this.year?.toString().slice(-2)}`,
      'cupo': this.cupo_org,
      'codigo_of_oc': this.filtroOcupa[0].codigo_of,
      'id_estado': this.user.id_estado,
      'id_cfs': this.user.id_centro,
      'id_ambito': this.id_ambito,
      'id_institucional': this.user.id_institucional,
      'estudiante_empresa': this.arrEstudianteOrganizacion,
      'id_organizacion': 0,
      'id_empresas': this.organizaciones
    });



    //console.log('todo:  ', this.formularioProgramacion.value);
    if(this.formularioProgramacion.get('id_alternativa_cumplimiento')?.getRawValue() != ''){
      let valida = ((this.formularioProgramacion.value).datosUC[0].unidadesCurriculares).filter((v:any) => { return v.id_formador == '' ?  false : true; });
      if (valida.length > 0){
        console.log('todo:  ', this.formularioProgramacion.value);

        this.mdl.cargando();
        await this.servicios.createAccionFormativa(this.formularioProgramacion.value).subscribe({
          next: (rs) => {
            console.log('prueba:  ',rs)
            this.mdl.cerrar();
            this.vuelve.emit({value: false, validador: true, cupo: this.cupo_org});
          },
          error: (error) => {
            this.errorMessage = error.message; // Muestra el mensaje de error al usuario
            //console.error("Error en el componente:", error); // Registro del error en el componente
          }
        });
      }
      else
      {
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = 'Al menos debe llenar una(1) unidad curricular del perfiles habilitado.';
        this.mdl.alerta();
      }
    }
    else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Seleccione alternativa de cumplimiento.';
      this.mdl.alerta();
    }



  }

  volver(){
    this.vuelve.emit({value: false, validador: false, cupo: this.cupo_org});
  }

}
